"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryFactory = exports.queryWithVariablesFactory = void 0;
const apollo_utilities_1 = require("apollo-utilities");
const react_1 = __importDefault(require("react"));
const helpers_1 = require("./helpers");
const useQuery = (query, variables = {}, options = {}) => {
    const saleor = helpers_1.useSaleorClient();
    const didMountRef = react_1.default.useRef(false);
    const prevDataRef = react_1.default.useRef(null);
    const prevUnsubRef = react_1.default.useRef(null);
    const { authenticated } = helpers_1.useAuth();
    const [result, setResult] = react_1.default.useState({
        data: null,
        error: null,
        loading: true,
    });
    const setData = react_1.default.useCallback((data) => {
        if (!apollo_utilities_1.isEqual(data, prevDataRef.current)) {
            prevDataRef.current = data;
            setResult({ data, loading: false, error: null });
        }
        else {
            setResult(result => (Object.assign(Object.assign({}, result), { loading: false })));
        }
    }, []);
    const { unsubscribe, setOptions, refetch: _refetch, loadMore: _loadMore, } = react_1.default.useMemo(() => saleor.legacyAPIProxy[query](variables, Object.assign(Object.assign({}, options), { onError: (error) => setResult(result => (Object.assign(Object.assign({}, result), { loading: false, error }))), onUpdate: (data) => {
            setData(data);
        } })), [query, options.skip, authenticated]);
    const refetch = react_1.default.useCallback((variables) => {
        setResult({ data: null, error: null, loading: true });
        _refetch(variables);
    }, [query]);
    const loadMore = react_1.default.useCallback((variables, mergeResults = true) => {
        if (_loadMore) {
            setResult(result => (Object.assign(Object.assign({}, result), { error: null, loading: true })));
            _loadMore(variables, mergeResults);
        }
    }, [query]);
    react_1.default.useEffect(() => {
        // skip on initial mount
        if (didMountRef.current) {
            refetch(variables);
        }
        else {
            didMountRef.current = true;
        }
    }, [JSON.stringify(variables)]);
    // unsubscribe from watcher on dismount
    react_1.default.useEffect(() => {
        if (prevUnsubRef.current) {
            prevUnsubRef.current();
        }
        prevUnsubRef.current = unsubscribe;
        return () => {
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, [options.skip, authenticated]);
    return Object.assign(Object.assign({}, result), { loadMore,
        refetch,
        setOptions });
};
exports.queryWithVariablesFactory = (query) => (variables, options) => useQuery(query, variables, options);
exports.queryFactory = (query) => (options) => useQuery(query, undefined, options);
//# sourceMappingURL=useQuery.js.map